import React from 'react'
import { isEmpty, capitalize } from 'lodash'
import { Link } from 'react-router-dom'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'

import { getWindowHeight } from '../../lib/util.js'
import errors from '../../lib/errors.js'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'
import ErrorDialog from '../UI/ErrorDialog'
import LinearLoader from '../UI/LinearLoader'

import DisplayFormula from './DisplayFormula'
import formattedReferences from './formattedReferences'

import Resource from '../../stores/resource'
const FormulaStore = Resource('formulas')
const ReferenceValueStore = Resource('reference-values')

class FormulaCard extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      referencedFormulas: [],
      dependentFormulas: [],
      referencedValues: [],
      error: '',
      loading: true
    }

    // Data can be received either as formula or itemData.
    this.formula = this.props.formula || this.props.itemData
  }

  componentWillMount() {
    const formula = this.formula
    const referencedFormulaIds = formula.attributes.referencedFormulas
    const referencedValueIds = formula.attributes.referencedValues
    FormulaStore.find(formula.id)
      .then(result => {
        const dependentFormulaIds = result.data.attributes.dependentFormulas
        const promises = [
          FormulaStore.findAll({ ids: dependentFormulaIds }, [], 1, 1000),
          FormulaStore.findAll({ ids: referencedFormulaIds }, [], 1, 1000),
          ReferenceValueStore.findAll({ ids: referencedValueIds }, [], 1, 1000)
        ]
        return Promise.all(promises)
      })
      .then(results => {
        this.setState({
          dependentFormulas: results[0].data,
          referencedFormulas: results[1].data,
          referencedValues: results[2].data,
          loading: false
        })
      })
      .catch(error =>
        this.setState({ error: errors.unpack(error), loading: false })
      )
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  render() {
    const formula = this.formula
    const actualFormula = formula.attributes.formula
    const referencedValues = this.state.referencedValues
    const referencedFormulas = this.state.referencedFormulas
    const dependentFormulas = this.state.dependentFormulas
    const cardStyle = {
      overflowY: 'auto',
      minHeight: '200px',
      maxHeight: `${getWindowHeight() - 500}px`
    }

    return (
      <Card style={cardStyle}>
        <CardTitle
          title={formula.attributes.name}
          subtitle={`${capitalize(
            formula.attributes.formulaType
          )} formula - ${formattedReferences(formula)}`}
        />

        <CardText>
          <div>
            <strong>Formula:</strong>
            <br />
            <DisplayFormula
              style={{ margin: '10px' }}
              formula={actualFormula}
              includeResult={true}
            />
          </div>

          {formula.attributes.notes && (
            <p>
              <strong>Notes:</strong> {formula.attributes.notes}
            </p>
          )}

          {this.state.loading && <LinearLoader />}

          {!isEmpty(referencedValues) && (
            <div>
              <strong>Values used (including referenced formulas):</strong>
              <ul>
                {referencedValues.map(value => (
                  <li key={value.id}>
                    <Link to={`/reference-values/${value.id}`}>
                      {value.attributes.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {!isEmpty(referencedFormulas) && (
            <div>
              <strong>Formulas used:</strong>
              <ul>
                {referencedFormulas.map(formula => (
                  <li key={formula.id}>
                    <Link to={`/formulas/${formula.id}`}>
                      {formula.attributes.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {!isEmpty(dependentFormulas) && (
            <div>
              <strong>Other formulas referencing this formula:</strong>
              <ul>
                {dependentFormulas.map(formula => (
                  <li key={formula.id}>
                    <Link to={`/formulas/${formula.id}`}>
                      {formula.attributes.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </CardText>

        <CardActions>
          {this.props.editCallback && (
            <EditButton onTouchTap={this.props.editCallback} />
          )}
          {this.props.deleteCallback && (
            <DeleteButton
              onTouchTap={this.props.deleteCallback}
              confirmMessage={
                <p>
                  Are you sure you want to delete{' '}
                  <strong>{formula.attributes.name}</strong>? There's no undo.
                </p>
              }
            />
          )}
          {this.props.closeCallback && (
            <CloseButton onTouchTap={this.props.closeCallback} />
          )}
        </CardActions>

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>
      </Card>
    )
  }
}

export default FormulaCard



// WEBPACK FOOTER //
// ./src/components/Formulas/FormulaCard.jsx